import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "preview", "placeholder"];

  disconnect() {
    this.releaseUrl();
  }

  update() {
    this.releaseUrl();
    const file = this.inputTarget.files?.[0];
    this.previewTarget.classList.toggle("hidden", !file);
    this.placeholderTarget.classList.toggle("hidden", !!file);
    if (file) this.previewTarget.src = this.fileUrl = URL.createObjectURL(file);
    else this.previewTarget.removeAttribute("src");
  }

  releaseUrl() {
    if (this.fileUrl) URL.revokeObjectURL(this.fileUrl);
    this.fileUrl = null;
  }
}
